<template>
  <b-sidebar
    id="sidebar-create-ask"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Ask additional quote') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="cancel(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="askQuoteVal">

          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('About')"
                label-for="about"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('About')"
                  rules="required"
                >
                  <b-form-textarea
                    id="about"
                    v-model="askQuote.about"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t('Dc amount')"
                rules="required|integer|min_value:0"
              >
                <b-form-group
                  :label="$t('Dc amount')"
                  label-for="dc_amount"
                >
                  <b-form-input
                    v-model="askQuote.dc_amount"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t('Phd amount')"
                rules="required|integer|min_value:0"
              >
                <b-form-group
                  :label="$t('Phd amount')"
                  label-for="phd_amount"
                >
                  <b-form-input
                    v-model="askQuote.phd_amount"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t('Dc targeted amount')"
                rules="required|integer|min_value:0"
              >
                <b-form-group
                  :label="$t('Dc targeted amount')"
                  label-for="dc_targeted_amount"
                >
                  <b-form-input
                    v-model="askQuote.dc_targeted_amount"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t('Phd targeted amount')"
                rules="required|integer|min_value:0"
              >
                <b-form-group
                  :label="$t('Phd targeted amount')"
                  label-for="phd_targeted_amount"
                >
                  <b-form-input
                    v-model="askQuote.phd_targeted_amount"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t('Trainee amount')"
                rules="required|integer|min_value:0"
              >
                <b-form-group
                  :label="$t('Trainee amount')"
                  label-for="trainee_amount"
                >
                  <b-form-input
                    v-model="askQuote.trainee_amount"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('File')"
                label-for="file"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('File')"
                  rules="required|file-size:10"
                >
                  <b-form-file
                    v-model="askQuote.file"
                    :placeholder="$t('Choose a file or drop it here...')"
                    accept="application/pdf"
                    :drop-placeholder="$t('Drop file here...')"
                    :state="errors.length > 0 ? false:null"
                    @change="handleFile"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            variant="success"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Ask additional quote') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="cancel(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput,
  BSidebar, BRow, BCol, BFormFile, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, integer, minValue } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormFile,
    BFormTextarea,
  },
  data() {
    return {
      required,
      integer,
      minValue,
    }
  },
  computed: {
    askQuote() {
      return this.$store.state[this.MODULE_NAME].askQuote
    },
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
  },
  created() {
    localize(this.$i18n.locale)
    this.clear()
  },
  methods: {
    clear() {
      this.$store.commit(`${this.MODULE_NAME}/ASK_QUOTE_GET`, {
        period: this.letter.period?.id,
        dc_amount: 0,
        phd_amount: 0,
        phd_targeted_amount: 0,
        dc_targeted_amount: 0,
        trainee_amount: 0,
      })
      if (this.$refs.askQuoteVal) this.$refs.askQuoteVal.reset()
    },
    handleFile(e) {
      // eslint-disable-next-line prefer-destructuring
      this.askQuote.base64 = e.target.files[0]
    },
    cancel(hide) {
      this.clear()
      hide()
    },
    submit(hide) {
      this.$refs.askQuoteVal.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.askQuote, `${this.MODULE_NAME}/sendAskQuote`, () => {
            this.$emit('refetchData')
            this.clear()
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style>
#sidebar-create-ask {
  width: 50rem;
}
</style>
